/**
 * Tracking d'adoption / usage produit (Super Admin / CSM).
 * Événements métier sparses — pas de analytics de chaque clic.
 */

export const USAGE_EVENTS = [
  'login',
  'logout',
  'session_start',
  'page_view',
  'pos_sale_completed',
  'client_created',
  'appointment_created',
  'stock_movement_created',
] as const;

export type UsageEventName = (typeof USAGE_EVENTS)[number];

export type UsageEventMeta = Record<string, string | number | boolean>;

export interface UsageEventPayload {
  eventId: string;
  businessId: string;
  userId: string;
  role?: string;
  event: UsageEventName;
  path?: string;
  module?: string;
  meta?: UsageEventMeta;
  sessionId: string;
  ts: number;
}

export interface UsageTrackingContext {
  businessId: string | null;
  userId: string | null;
  role?: string | null;
  /** Super Admin / CSM en mode console : ne pas tracker */
  suppress?: boolean;
}

/** Agrégat journalier par business (Firestore, écrit par Cloud Functions). */
export interface UsageDailyAggregate {
  id: string;
  businessId: string;
  date: string; // yyyy-mm-dd (UTC)
  logins: number;
  sessionStarts: number;
  pageViews: number;
  posSales: number;
  clientsCreated: number;
  appointmentsCreated: number;
  stockMovements: number;
  modules: Record<string, number>;
  lastEventAt: Date | null;
  lastUserId?: string;
  lastEvent?: string;
}

export interface UsageBusinessAdoptionRow {
  businessId: string;
  businessName: string;
  logins: number;
  posSales: number;
  clientsCreated: number;
  appointmentsCreated: number;
  stockMovements: number;
  pageViews: number;
  activeDays: number;
  lastEventAt: Date | null;
  topModules: Array<{ module: string; count: number }>;
}
